const firebaseConfig = {
    apiKey: "AIzaSyCVcDnuA7dEBpGDk06hYUU302pD2kz5pkA",
    authDomain: "holy-creasent-hospital.firebaseapp.com",
    projectId: "holy-creasent-hospital",
    storageBucket: "holy-creasent-hospital.appspot.com",
    messagingSenderId: "780264013794",
    appId: "1:780264013794:web:c679892e08baafcc7bc3bb"
};
export default firebaseConfig;